import React from "react";

// ---------------------------------------------------------------------------
// ไอคอนของระบบ — ใช้ฟอนต์ fa-light-300.woff (Font Awesome Light) ใน assets/font
// เรียกด้วยชื่อเชิงความหมาย ไม่ต้องจำรหัสอักขระ:  <Icon name="dashboard" />
// ถ้าใส่ชื่อที่ไม่มีในตาราง จะแสดงค่าที่ส่งมาตรง ๆ (เผื่อ emoji เดิมที่ยังไม่ได้แปลง)
// ---------------------------------------------------------------------------

export const ICONS = {
  // ทั่วไป / นำทาง
  dashboard: "\uf0e4",
  modules: "\uf12e",
  home: "\uf015",
  search: "\uf002",
  filter: "\uf0b0",
  menu: "\uf0c9",
  close: "\uf00d",
  check: "\uf00c",
  plus: "\uf067",
  minus: "\uf068",
  edit: "\uf040",
  trash: "\uf1f8",
  copy: "\uf0c5",
  link: "\uf0c1",
  external: "\uf08e",
  print: "\uf02f",
  download: "\uf019",
  upload: "\uf093",
  refresh: "\uf021",
  recycle: "\uf1b8",
  settings: "\uf013",
  lock: "\uf023",
  unlock: "\uf09c",
  logout: "\uf08b",
  login: "\uf090",
  info: "\uf05a",
  question: "\uf059",
  warning: "\uf071",
  success: "\uf058",
  star: "\uf005",
  heart: "\uf004",
  eye: "\uf06e",
  send: "\uf1d8",
  clock: "\uf017",
  history: "\uf1da",
  bell: "\uf0f3",
  flag: "\uf024",
  gift: "\uf06b",
  bulb: "\uf0eb",
  bolt: "\uf0e7",
  globe: "\uf0ac",
  desktop: "\uf108",
  mobile: "\uf10b",
  qrcode: "\uf029",

  // ลูกค้า / คน
  users: "\uf0c0",
  user: "\uf007",
  userPlus: "\uf234",
  staff: "\uf0f0",
  target: "\uf140",
  badge: "\uf0a3",
  trophy: "\uf091",

  // สื่อสาร
  chat: "\uf086",
  comment: "\uf075",
  megaphone: "\uf0a1",
  mail: "\uf0e0",
  phone: "\uf095",

  // การจอง / เวลา
  calendar: "\uf073",
  calendarAlt: "\uf133",
  compass: "\uf14e",
  ticket: "\uf145",

  // สินค้า / คลัง
  tags: "\uf02c",
  tag: "\uf02b",
  box: "\uf1b2",
  boxes: "\uf1b3",
  cart: "\uf07a",
  cartPlus: "\uf217",
  receipt: "\uf1ac",
  store: "\uf19c",
  truck: "\uf0d1",

  // การเงิน / เอกสาร
  card: "\uf09d",
  money: "\uf0d6",
  dollar: "\uf155",
  chartLine: "\uf201",
  chartPie: "\uf200",
  chartBar: "\uf080",
  file: "\uf15b",
  fileText: "\uf15c",
  folder: "\uf07b",
  checkSquare: "\uf14a",
  bank: "\uf19c",

  // สถานที่ / ทรัพย์สิน
  pin: "\uf041",
  building: "\uf1ad",
  car: "\uf1b9",
  motorcycle: "\uf21c",
  wrench: "\uf0ad",
  key: "\uf084",

  // โมเดลธุรกิจ
  stethoscope: "\uf0f1",
  medkit: "\uf0fa",
  paw: "\uf1b0",
  heartbeat: "\uf21e",
  moon: "\uf186",
  scissors: "\uf0c4",
  bed: "\uf236",
  graduation: "\uf19d",
  coffee: "\uf0f4",
  plane: "\uf072",
};

/**
 * <Icon name="calendar" />
 * name = ชื่อจากตาราง ICONS · size = ขนาดตัวอักษร (px)
 */
export default function Icon({ name, size, className = "", style, ...rest }) {
  const glyph = ICONS[name];
  return (
    <i className={`ic ${className}`} aria-hidden="true" style={size ? { fontSize: size, ...style } : style} {...rest}>
      {glyph || name}
    </i>
  );
}
